import React, { useEffect, useState } from 'react'
import TextField from '../Reusable/Form/TextInput'
import Select, { } from 'react-select'
import makeAnimated from 'react-select/animated';
import ColorField from '../Reusable/Form/ColorField';
import NumberField from '../Reusable/Form/NumberField';

const animatedComponents = makeAnimated();

const StatusForm = ({ register, errors, statusList, setValue, watch, getValues, clearErrors }: any) => {
  const [defaultValue, setDefaultValue] = useState()
  const onChange = (value: any) => {
    setValue("next_status", value)
    setDefaultValue(value)
  };

  useEffect(() => {
    if (!defaultValue) {
      setDefaultValue(watch("next_status"))
    }
  }, [watch("next_status")])


  return (
    <>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <NumberField
          label={"Priority"}
          register={register("priority")}
          errors={errors?.priority}
          value={getValues().priority}
          setValue={setValue}
          clearErrors={clearErrors}
        />
        <ColorField
          label={"Color"}
          register={register("color")}
          errors={errors?.charge}
        />
        <div className='mt-8'>
          <div>
            <input
              className="cursor-pointer"
              {...register("is_allow_to_create_rtv")}
              type="checkbox"
            />
            <span className="ml-2">Allow To Create RTV Order</span>
          </div>
          <div>
            <input
              className="cursor-pointer"
              {...register("is_final_state")}
              type="checkbox"
            />
            <span className="ml-2">Select As Final State</span>
          </div>

          <div>
            <input
              className="cursor-pointer"
              {...register("is_rider_status")}
              type="checkbox"
            />
            <span className="ml-2">Is Rider Status</span>
          </div>
        </div>

      </div>
      <div className='mx-4 mt-4'>
        <label htmlFor="">Can Change Status To</label>
        <Select
          value={defaultValue}
          components={animatedComponents}
          closeMenuOnSelect={false}
          options={statusList}
          onChange={onChange}
          isMulti
        />
      </div>
    </>
  )
}

export default StatusForm
